import { Action, Module, VuexModule } from "vuex-module-decorators";
import { Roles } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class RoleModule extends VuexModule {
  @Action
  [Roles.saveRole](values) {
    return new Promise<void>((resolve, reject) => {
      ApiService.post("/role/save", values, {headers: {'Content-Type': 'application/json'}})
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }

  @Action
  [Roles.deleteRole](values) {
    return new Promise<void>((resolve, reject) => {
      ApiService.post("/role/delete", values, {headers: {'Content-Type': 'application/json'}})
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }

  @Action
  [Roles.findPageRole](values) {
    return new Promise<void>((resolve, reject) => {
      ApiService.post("/role/findPage", values)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }

  @Action
  [Roles.findAllRole](values) {
    return new Promise<void>((resolve, reject) => {
      ApiService.get("/role/findAll", values)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }

  @Action
  [Roles.findRoleMenu](values) {
    return new Promise<void>((resolve, reject) => {
      ApiService.post("/role/findRoleMenus", values)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }

  @Action
  [Roles.saveRoleMenu](values) {
    return new Promise<void>((resolve, reject) => {
      ApiService.post("/role/saveRoleMenus", values)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }

  @Action
  [Roles.findRole](values) {
    return new Promise<void>((resolve, reject) => {
      ApiService.post("/role/findRole", values)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }

 
}
